import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { endOfDay, startOfDay } from 'date-fns';
import { DateRange } from '../../../shared/lib/date/dateRange';
import { DialogMessageDateBlock } from './dialogMessageDateBlock';

export const createBlockForMessage = (message: DialogMessageViewModel): DialogMessageDateBlock => {
  return new DialogMessageDateBlock(new DateRange(startOfDay(new Date(message.createdAt)), endOfDay(new Date(message.createdAt))));
};
